import { render, staticRenderFns } from "./SplitSideBar.vue?vue&type=template&id=7c7fa7a7&lang=html&"
import script from "./SplitSideBar.vue?vue&type=script&lang=js&"
export * from "./SplitSideBar.vue?vue&type=script&lang=js&"
import style0 from "./SplitSideBar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SplitSideBar.vue"
export default component.exports